import { render, staticRenderFns } from "./ChatBot.vue?vue&type=template&id=02dacec1&scoped=true&lang=pug"
import script from "./ChatBot.vue?vue&type=script&lang=ts"
export * from "./ChatBot.vue?vue&type=script&lang=ts"
import style0 from "./ChatBot.vue?vue&type=style&index=0&id=02dacec1&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02dacec1",
  null
  
)

export default component.exports